import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpClientService } from 'src/app/core/http/http-client';

@Injectable({
  providedIn: 'root'
})
// @Injectable()
export class GetSignatureService {

  constructor(private http: HttpClientService) { }

  get() {
    return this.http.get<{data: any}>('utils/encrypted-info');
  }
}
